import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const Blogs = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Insights & Blogs | Protek Consult</title>
        <meta name="description" content="Stay tuned for expert insights, industry updates, and project stories on civil engineering, architectural trends, and project management from Protek Consult." />
        <meta name="keywords" content="civil engineering blog, architecture trends, construction insights, Protek Consult blog" />
        <link rel="canonical" href="https://protekconsult.com/blogs" />
        <meta property="og:title" content="Insights & Blogs | Protek Consult" />
        <meta property="og:description" content="Read expert insights and industry updates on civil engineering and architecture." />
        <meta property="og:url" content="https://protekconsult.com/blogs" />
      </Helmet>
    <div style={{ minHeight: '60vh', padding: '100px 20px 40px 20px', textAlign: 'center' }}>
      <h1>Insights Coming Soon <span style={{ color: '#812121' }}></span></h1>
      <div style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
        <p style={{ marginBottom: '20px', fontSize: '1.2rem' }}>
          We're currently curating expert insights, industry updates, and project stories to share with you.
        </p>
        <p style={{ marginBottom: '20px', fontSize: '1.2rem' }}>
          Our blog section is under development and will soon feature valuable content on civil engineering, architectural trends, regulatory tips, and project management best practices.
        </p>
        <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#812121' }}>
          Stay tuned—Protek Consult's expertise will soon be just a scroll away.
        </p>
      </div>
    </div>
    </>
  );
};

export default Blogs; 